import { useState } from 'react'
import { graphql } from 'gatsby'
import { normalizedData } from '@utils'
import Layout from '@layout'
import Header from '@layout/header/layout-01'
import Footer from '@layout/footer/layout-01'
import PageHeader from '@containers/page-header/layout-04'
import BSWProduktklassifizierungArea from '@containers/bsw-produktklassifizierung/layout-01'

const BSWProduktklassifizierungPage = ({ location, data }) => {
  const content = normalizedData(data?.strapiPage?.content || [])
  const [section, setSection] = useState(null)

  return (
    <Layout location={location}>
      <Header />
      <main className="site-wrapper-reveal">
        <PageHeader
          data={{
            ...content['header-section']
          }}
        />
        <BSWProduktklassifizierungArea
          einleitung={{ ...content['einleitung-section'] }}
          search={{ ...content['search-section'] }}
          data={
            section
              ? {
                  ...content[section]
                }
              : {}
          }
          onSetSection={setSection}
          bg="white"
        />
      </main>
      <Footer />
    </Layout>
  )
}

export { Head } from '@components/head'

export const query = graphql`
  query BSWProduktklassifizierungPageQuery($title: String, $locale: String) {
    strapiPage(
      title: { eq: $title }
      pageType: { eq: "innerpage" }
      locale: { eq: $locale }
    ) {
      content {
        ...StrapiPageContent
      }
      seo {
        ...StrapiPageSEO
      }
    }
  }
`

export default BSWProduktklassifizierungPage
